export default value => {
  if (value === 'CREATE') {
    return 'Create';
  } if (value === 'PAYMENT_METHOD_ADDED') {
    return 'Payment Method Added';
  } if (value === 'ACTIVE') {
    return 'Active';
  } if (value === 'PAYMENT_METHOD_UPDATED') {
    return 'Payment Method Updated';
  } if (value === 'PROCESSING') {
    return 'Processing';
  } if (value === 'PAID') {
    return 'Paid';
  } if (value === 'INCOMPLETE') {
    return 'Incomplete';
  } if (value === 'PAST_DUE') {
    return 'Outstanding';
  } if (value === 'FAILED') {
    return 'Failed';
  } if (value === 'CANCELLED') {
    return 'Cancelled';
  } if (value === 'PAUSED') {
    return 'Paused';
  } if (value === 'RESUMED') {
    return 'Resumed';
  } if (value === 'DEACTIVATED') {
    return 'Deactivated';
  } if (value === 'SWITCHED_PLAN') {
    return 'Switched Plan';
  } if (value === 'SWITCHED_PAYMENT_DATE') {
    return 'Switched Payment Date';
  } if (value === 'ADDED_DISCOUNT') {
    return 'Added Discount';
  } if (value === 'MANUAL_PAYMENT') {
    return 'Manual Payment';
  } if (value === 'ACTIVATED') {
    return 'Activated';
  } return null;
};
